/* ADD+ chip quick-pick (2026-07-25) — ported from the bundle picker's inline
   variant picker (bundle-picker.js openInlineVariants, the Avaria pattern).

   Click ADD+ on a card:
     - single-variant product  -> adds instantly
     - multi-variant product   -> small picker panel opens ON the card
       (option chips, color values as 26px swatch circles, unavailable combos
       greyed) -> Add
   The chosen variant id is written into the card's hidden product form and the
   form is submitted, so Dawn's product-form.js does the cart add + opens the
   drawer (incl. is-empty clearing). Chip shows pressed / busy spinner / check
   feedback. Delegated listeners: works on homepage, search, collection grids
   and the COMPLETE-THE-LOOK sliders, including injected cards.

   Chip contract (set in boots-collection-card.liquid / card-product.liquid):
     class="card-add-chip" data-handle data-form-id [data-preferred-color]      */
(function () {
  'use strict';

  var productCache = {};   // handle -> Promise<product json>
  var active = null;       // { panel, chip }

  /* ── swatches (copied from bundle-picker.js so the two stay in sync) ── */
  var GRAD = {
    /* metals = glossy "polished" stack: specular top-left + shading bottom-right */
    gold: 'radial-gradient(circle at 30% 25%, rgba(255,255,255,.95) 0%, rgba(255,255,255,0) 36%), radial-gradient(circle at 72% 85%, rgba(100,62,12,.42) 0%, rgba(100,62,12,0) 55%), linear-gradient(135deg,#FAEDBB 0%,#F0D28A 28%,#D9AE5F 54%,#B78538 78%,#E9C97F 100%)',
    silver: 'radial-gradient(circle at 30% 25%, rgba(255,255,255,1) 0%, rgba(255,255,255,0) 36%), radial-gradient(circle at 72% 85%, rgba(50,50,55,.38) 0%, rgba(50,50,55,0) 55%), linear-gradient(135deg,#FFFFFF 0%,#EAEAE9 28%,#C9C9C8 54%,#A0A0A0 78%,#E4E4E3 100%)',
    whitegold: 'radial-gradient(circle at 30% 25%, rgba(255,255,255,1) 0%, rgba(255,255,255,0) 36%), radial-gradient(circle at 72% 85%, rgba(95,90,70,.3) 0%, rgba(95,90,70,0) 55%), linear-gradient(135deg,#FFFFFF 0%,#F2EFE6 28%,#DCD6C6 54%,#BDB6A2 78%,#EFEBDF 100%)',
    rosegold: 'radial-gradient(circle at 30% 25%, rgba(255,255,255,.93) 0%, rgba(255,255,255,0) 36%), radial-gradient(circle at 72% 85%, rgba(122,55,36,.4) 0%, rgba(122,55,36,0) 55%), linear-gradient(135deg,#F9DFD0 0%,#EFBFA6 28%,#DB9C80 54%,#B87360 78%,#EFC7B0 100%)',
    twotone: 'radial-gradient(circle at 30% 25%, rgba(255,255,255,.92) 0%, rgba(255,255,255,0) 34%), radial-gradient(circle at 72% 85%, rgba(55,45,28,.36) 0%, rgba(55,45,28,0) 55%), linear-gradient(135deg,#FAEDBB 0%,#E4BC6C 34%,#BC8A3E 49%,#F2F2F1 51%,#C6C6C5 74%,#9A9A99 100%)',
    black: 'linear-gradient(135deg,#5a5a5a,#1a1a1a)',
    pearl: 'linear-gradient(135deg,#ffffff,#efe9df)',
    red: 'linear-gradient(135deg,#ff7a7a,#c0392b)',
    pink: 'linear-gradient(135deg,#ffd1e0,#e06a98)',
    purple: 'linear-gradient(135deg,#cda8e6,#7b3fa0)',
    blue: 'linear-gradient(135deg,#7fb0ec,#2f5fb0)',
    lightblue: 'linear-gradient(135deg,#cfe4fb,#7fb0ec)',
    aqua: 'linear-gradient(135deg,#cdeef0,#5fb6c4)',
    green: 'linear-gradient(135deg,#8fd6a6,#2f8f55)',
    lightgreen: 'linear-gradient(135deg,#d6eaa3,#8bc34a)',
    yellow: 'linear-gradient(135deg,#fff3a0,#f3d23b)',
    orange: 'linear-gradient(135deg,#ffcf9e,#e8893b)',
    clear: 'linear-gradient(135deg,#ffffff,#e3e3e3)',
    brown: 'linear-gradient(135deg,#b08968,#6f4e37)',
    rainbow: 'linear-gradient(135deg,#e05a5a,#e8a13b 25%,#e8d93b 45%,#57b86a 65%,#4a78c4 82%,#8b5fb0)'
  };
  function isColorOption(name) {
    return /colou?r|finish|metal|tone|material|plating|stone|gem/i.test(name || '');
  }
  function swatchColor(val) {
    var s = String(val || '').trim().toLowerCase();
    if (!s) return null;
    if (s.indexOf(' - ') !== -1) s = s.split(' - ').pop().trim();
    s = s.replace(/\b(\d{1,3}\s*k|s?925|sterling|solid)\b/g, ' ').replace(/\s+/g, ' ').trim();
    if (/rainbow/.test(s)) return GRAD.rainbow;
    if (/two[\s-]?tone|2[\s-]?tone|tri[\s-]?tone|multi/.test(s)) return GRAD.twotone;
    if (/gold/.test(s)) {
      if (/rose/.test(s)) return GRAD.rosegold;
      if (/white/.test(s)) return GRAD.whitegold;
      return GRAD.gold;
    }
    if (/silver/.test(s)) return GRAD.silver;
    if (/platinum/.test(s)) return GRAD.whitegold;
    if (/gun|graphite|charcoal/.test(s)) return GRAD.black;
    if (/ruby|garnet|siam|cherry|\bred\b|scarlet/.test(s)) return GRAD.red;
    if (/rose|\bpink\b|blush|berry|sakura|fuchsia|magenta/.test(s)) return GRAD.pink;
    if (/amethyst|alexandrite|violet|purple|lavender|lilac|grape|plum/.test(s)) return GRAD.purple;
    if (/peridot|mint|lime|citrus/.test(s)) return GRAD.lightgreen;
    if (/emerald|jade|viridian|evergreen|forest|\bgreen\b/.test(s)) return GRAD.green;
    if (/aquamarine|\baqua\b|turquoise|teal|ocean|mist/.test(s)) return GRAD.aqua;
    if (/light\s*sapphire|light\s*blue|\bsky\b/.test(s)) return GRAD.lightblue;
    if (/sapphire|\bblue\b|topaz/.test(s)) return GRAD.blue;
    if (/citrine|jonquil|\byellow\b|amber|lemon/.test(s)) return GRAD.yellow;
    if (/\borange\b|coral|tangerine|peach/.test(s)) return GRAD.orange;
    if (/diamond|crystal|clear|white|opal|moonstone/.test(s)) return GRAD.clear;
    if (/pearl|ivory|cream/.test(s)) return GRAD.pearl;
    if (/onyx|\bblack\b|jet|obsidian/.test(s)) return GRAD.black;
    if (/chocolate|coffee|mocha|\bbrown\b|bronze|copper/.test(s)) return GRAD.brown;
    return null;
  }

  function normalizeImgSrc(src) {
    if (!src) return '';
    var clean = String(src).replace(/_(pico|icon|thumb|small|compact|medium|large|grande|original|master|\d+x\d*)(?=\.[a-z]{3,4}(\?|$))/i, '');
    if (clean.indexOf('//') === 0) clean = 'https:' + clean;
    return clean;
  }
  function sized(src, w) {
    var u = normalizeImgSrc(src);
    if (!u) return u;
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function fetchProduct(handle) {
    if (!productCache[handle]) {
      productCache[handle] = fetch('/products/' + handle + '.js').then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      });
    }
    return productCache[handle];
  }

  /* /products/x.js caps at 250 variants. Big DIY products (e.g. the 720-variant
     birthstone rings) carry the full "opt1|opt2|opt3" -> variant-id map in a
     metafield, exposed via the tiny ?view=cqp template (2026-07-26). */
  var mapCache = {};
  function fetchCapMap(handle) {
    if (!mapCache[handle]) {
      mapCache[handle] = fetch('/products/' + handle + '?view=cqp')
        .then(function (r) { return r.ok ? r.json() : { map: null }; })
        .then(function (d) { return (d && d.map) || null; })
        .catch(function () { return null; });
    }
    return mapCache[handle];
  }

  function comboAvailable(product, optIdx, val, selected) {
    return (product.variants || []).some(function (v) {
      if (!v.available) return false;
      if (v['option' + (optIdx + 1)] !== val) return false;
      return product.options.every(function (opt, idx) {
        if (idx === optIdx) return true;
        var sel = selected[idx];
        return !sel || v['option' + (idx + 1)] === sel;
      });
    });
  }
  function updateAvail(panel, product, selected, capMap) {
    /* with a full variant map the truncated variant list can't be trusted for
       availability — everything in the map is purchasable (policy CONTINUE) */
    if (capMap) {
      panel.querySelectorAll('[data-opt-idx]').forEach(function (btn) {
        btn.classList.remove('cqp-unavailable');
      });
      return;
    }
    panel.querySelectorAll('[data-opt-idx]').forEach(function (btn) {
      var ok = comboAvailable(product, parseInt(btn.dataset.optIdx, 10), btn.dataset.optVal, selected);
      btn.classList.toggle('cqp-unavailable', !ok);
    });
  }
  function variantImageFor(product, optIdx, val) {
    var key = 'option' + (optIdx + 1);
    var v = (product.variants || []).find(function (v) {
      return v[key] === val && v.featured_image && v.featured_image.src;
    });
    return v ? normalizeImgSrc(v.featured_image.src) : null;
  }

  /* ── chip feedback ── */
  function chipBusy(chip, on) { chip.classList.toggle('is-busy', !!on); }
  function chipAdded(chip) {
    chip.classList.remove('is-busy');
    chip.classList.add('is-added');
    setTimeout(function () { chip.classList.remove('is-added'); }, 1500);
  }

  /* ── submit through the card's hidden product form ── */
  function submitVariant(chip, variantId) {
    var form = document.getElementById(chip.dataset.formId);
    if (!form) return;
    var input = form.querySelector('input[name="id"]');
    if (variantId && input) input.value = variantId;
    chipBusy(chip, true);
    try { form.requestSubmit(); } catch (e) { form.submit(); }
    /* product-form.js opens the drawer; the chip flips to a check once the add
       has had time to land (no reliable event exists this early in the page). */
    setTimeout(function () { chipAdded(chip); }, 900);
  }

  /* ── live hero swap on the card when an option with an image is picked ── */
  function swapCardImage(chip, variant, product) {
    var src = (variant && variant.featured_image && variant.featured_image.src) || null;
    if (!src) return;
    var scope = chip.closest('.boots-card__media') || chip.closest('.card__inner');
    if (!scope) return;
    var img = scope.querySelector('.card-gal__img.is-active') ||
              scope.querySelector('.boots-card__img') ||
              scope.querySelector('img');
    if (!img) return;
    var next = sized(src, 600);
    if (img.src === next) return;
    img.style.transition = 'opacity .2s ease';
    img.style.opacity = '0';
    setTimeout(function () { img.src = next; img.srcset = ''; img.style.opacity = '1'; }, 160);
  }

  /* ── panel ── */
  function closePanel() {
    if (!active) return;
    active.panel.remove();
    if (active.backdrop) active.backdrop.remove();
    active = null;
  }

  function openPanel(chip, product, capMap) {
    var anchor = chip.closest('.boots-card__media') || chip.closest('.card__inner') || chip.parentElement;
    var selected = {};
    var currentVariant = null;
    /* on small screens the in-card panel gets clipped by the card — render a
       fixed bottom sheet on <body> instead (2026-07-26 mobile fix) */
    var isSheet = window.matchMedia('(max-width: 749px)').matches;

    var panel = document.createElement('div');
    panel.className = 'cqp-panel' + (isSheet ? ' cqp-panel--sheet' : '');
    /* the whole card is often an <a> — nothing inside the panel may navigate */
    panel.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); });

    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'cqp-close';
    close.setAttribute('aria-label', 'Close');
    close.innerHTML = '&#x2715;';
    close.addEventListener('click', function () { closePanel(); });
    panel.appendChild(close);

    var sheetThumb = null;
    if (isSheet) {
      var head = document.createElement('div');
      head.className = 'cqp-head';
      sheetThumb = document.createElement('img');
      sheetThumb.className = 'cqp-thumb';
      sheetThumb.alt = product.title || '';
      if (product.featured_image) sheetThumb.src = sized(product.featured_image, 140);
      var sheetTitle = document.createElement('div');
      sheetTitle.className = 'cqp-title';
      sheetTitle.textContent = product.title || '';
      head.appendChild(sheetThumb);
      head.appendChild(sheetTitle);
      panel.appendChild(head);
    }

    var addBtn = document.createElement('button');
    addBtn.type = 'button';
    addBtn.className = 'cqp-add';
    addBtn.disabled = true;
    addBtn.textContent = 'Select an option';

    function money(cents) {
      return '$' + (cents / 100).toFixed(2);
    }
    function resolve() {
      currentVariant = (product.variants || []).find(function (v) {
        return product.options.every(function (opt, idx) {
          var sel = selected[idx];
          if (!sel) return false;
          return v['option' + (idx + 1)] === sel;
        });
      }) || null;
      /* combo beyond the 250-variant cap -> full metafield map */
      if (!currentVariant && capMap) {
        var allPicked = product.options.every(function (o, idx) { return !!selected[idx]; });
        if (allPicked) {
          var mid = capMap[product.options.map(function (o, idx) { return selected[idx]; }).join('|')];
          if (mid) currentVariant = { id: mid, available: true, price: product.price, featured_image: null };
        }
      }
      /* keep the sheet thumbnail in sync with the picked variant */
      if (sheetThumb) {
        var tsrc = (currentVariant && currentVariant.featured_image && currentVariant.featured_image.src) ||
                   product.featured_image;
        if (tsrc) sheetThumb.src = sized(tsrc, 140);
      }
      if (currentVariant && currentVariant.available) {
        addBtn.disabled = false;
        addBtn.textContent = 'Add — ' + money(currentVariant.price);
      } else if (currentVariant) {
        addBtn.disabled = true;
        addBtn.textContent = 'Sold out';
      } else {
        addBtn.disabled = true;
        addBtn.textContent = 'Select an option';
      }
      if (currentVariant) swapCardImage(chip, currentVariant, product);
    }

    var preferred = (chip.dataset.preferredColor || '').trim().toLowerCase();

    product.options.forEach(function (option, idx) {
      var uniq = option.values.filter(function (v, i, a) { return a.indexOf(v) === i; });
      if (uniq.length === 1) { selected[idx] = uniq[0]; return; }

      var group = document.createElement('div');
      var label = document.createElement('div');
      label.className = 'cqp-label';
      label.textContent = option.name;
      var wrap = document.createElement('div');
      wrap.className = 'cqp-values';
      var colorish = isColorOption(option.name);

      uniq.forEach(function (val) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'cqp-btn';
        btn.dataset.optIdx = idx;
        btn.dataset.optVal = val;
        var bg = null;
        if (colorish) {
          /* PDP parity: birthstone months render their gem swatch image
             (window.ALSwatches, same map the product page uses) */
          var gem = window.ALSwatches && window.ALSwatches.forValue && window.ALSwatches.forValue(val, option.name);
          if (gem) bg = 'url("' + gem + '")';
          if (!bg) bg = swatchColor(val);
          if (!bg) {
            var img = variantImageFor(product, idx, val);
            if (img) bg = 'url("' + sized(img, 60) + '")';
          }
        }
        if (bg) {
          btn.classList.add('cqp-swatch');
          btn.style.background = bg;
          btn.style.backgroundSize = 'cover';
          btn.style.backgroundPosition = 'center';
          btn.title = val;
          btn.setAttribute('aria-label', val);
        } else {
          btn.textContent = val;
        }
        function pick() {
          wrap.querySelectorAll('.cqp-btn').forEach(function (b) { b.classList.remove('active'); });
          btn.classList.add('active');
          selected[idx] = val;
          if (colorish) label.textContent = option.name + ': ' + val;
          resolve();
          updateAvail(panel, product, selected, capMap);
        }
        btn.addEventListener('click', pick);
        /* color filter active -> preselect that colorway */
        if (preferred && colorish && String(val).toLowerCase() === preferred) {
          setTimeout(pick, 0);
        }
        wrap.appendChild(btn);
      });

      group.appendChild(label);
      group.appendChild(wrap);
      panel.appendChild(group);
    });

    updateAvail(panel, product, selected, capMap);
    resolve();

    addBtn.addEventListener('click', function () {
      if (!currentVariant || !currentVariant.available) return;
      addBtn.disabled = true;
      addBtn.textContent = 'Adding…';
      submitVariant(chip, currentVariant.id);
      setTimeout(closePanel, 450);
    });
    panel.appendChild(addBtn);

    var backdrop = null;
    if (isSheet) {
      backdrop = document.createElement('div');
      backdrop.className = 'cqp-backdrop';
      backdrop.addEventListener('click', function () { closePanel(); });
      document.body.appendChild(backdrop);
      document.body.appendChild(panel);
    } else {
      anchor.appendChild(panel);
    }
    active = { panel: panel, chip: chip, backdrop: backdrop };
  }

  function onChip(chip) {
    if (active && active.chip === chip) { closePanel(); return; }
    closePanel();
    chipBusy(chip, true);
    fetchProduct(chip.dataset.handle).then(function (product) {
      chipBusy(chip, false);
      var hasRealOptions =
        product.options && product.options.length > 0 &&
        !(product.options.length === 1 && product.options[0].name === 'Title') &&
        !(product.variants.length === 1);
      if (!hasRealOptions) {
        submitVariant(chip, product.variants[0] && product.variants[0].id);
      } else if ((product.variants || []).length >= 250) {
        /* possibly capped — fetch the full variant map before opening */
        chipBusy(chip, true);
        fetchCapMap(chip.dataset.handle).then(function (capMap) {
          chipBusy(chip, false);
          openPanel(chip, product, capMap);
        });
      } else {
        openPanel(chip, product, null);
      }
    }).catch(function () {
      chipBusy(chip, false);
      /* fall back to whatever variant the hidden form already holds */
      submitVariant(chip, null);
    });
  }

  document.addEventListener('click', function (e) {
    var chip = e.target.closest('.card-add-chip');
    if (chip && !chip.disabled && chip.dataset.handle) {
      e.preventDefault();
      e.stopPropagation();
      onChip(chip);
      return;
    }
    /* outside click closes the panel (panel's own handler stops propagation) */
    if (active && !e.target.closest('.cqp-panel')) closePanel();
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closePanel();
  });
})();
